<!-- Copyright: Seán I. O'Donoghue -->

<template>
  <nav :class="{selected}">
    <!-- by the lists (DL16, Seán, 2026-10-23): signed out, "Welcome to VIZBI" (#sign-in);
         none on, "Subscribe" (#subscribe, all three on); any, "Subscriptions" -->
    <PrimaryItem :to="target" class="mail" :selected>
      {{ label }}
    </PrimaryItem>
  </nav>
  <!-- title="Click to join VIZBI mailing list" -->
  <!-- <button ref="mailButton" :class="{selected: selected}" >
    <router-link to="#subscribe"> Join Mailing List </router-link>
  </button> -->
</template>

<script setup>
import PrimaryItem from "@/components/Navigation/Primary/Item.vue";

import {computed, ref, watch} from "vue";
import {useRoute} from "vue-router";
import useUserSafe from "@/composables/useUserSafe";
import {getIsSubscribed} from "@/composables/subscriptionLists";

const log = (msg) => process.env.VUE_APP_DEV && console.log(); // eslint-disable-line
const {isSignedIn, user} = useUserSafe();
const isSubscribed = computed(() => getIsSubscribed(user.value?.publicMetadata)); // any list
const label = computed(() => {
  if (!isSignedIn.value) return "Welcome to VIZBI";
  return isSubscribed.value ? "Subscriptions" : "Subscribe";
});
const target = computed(() => {
  if (!isSignedIn.value) return "#sign-in";
  return isSubscribed.value ? "#subscriptions" : "#subscribe";
});
const selected = ref(false);
const route = useRoute();

watch(
  route,
  () => {
    log(`Mailing list mounted()`);
    if (route.name && route.name === "Mail") {
      // set button to autofocus
      // https://michaelnthiessen.com/set-focus-on-input-vue
      //this.$refs['mailButton'].focus();
      selected.value = true;
      log(`Current page is Mail view`);
    } else {
      // turn off autofocus
      selected.value = false;
      //this.$refs['mailButton'].blur();
    }
  },
  {immediate: true}
);
</script>

<style scoped>
nav {
  padding: 0;
  font-weight: 700;
  opacity: 0.65;
}
:is(nav.selected, nav:hover) {
  opacity: 1;
}
nav:hover {
  background-color: var(--focus-background-color);
  border-radius: 0.4rem;
}
nav .medium {
  font-size: 0.9rem;
}
nav .wide {
  font-size: 0.95rem;
}
nav .unlimited {
  font-size: 1rem;
}
:is(.medium, .wide, .unlimited) nav .mail {
  margin: -0.2rem 0 0 0; /*compensates for text-shadow (below) */
}
:deep(a) {
  /* for wide display */
  padding: 0 1em;
  color: var(--primary-navigation-color); /* override default link color */
  text-shadow: rgb(0, 0, 0) 0px 0px 6px;
}
.narrow .mail :deep(a) {
  color: var(--primary-navigation-color);
  justify-content: center;
  text-shadow: none;
}
:deep(a:hover) {
  color: var(--primary-navigation-color);
  background-color: none;
  border-radius: 0.4rem;
}
.lightMode.narrow .mail :deep(a) {
  color: var(--text-color-less-subtle);
  justify-content: center;
  text-shadow: none;
}
.narrow nav {
  display: inline-block;
  position: static;
  margin: 0 auto 0 auto;
  padding: 0.5rem 0;
  font-size: 1.5rem;
  opacity: 1;
  border-radius: 2rem;
  line-height: 2.3rem;
  width: 100%;
  text-align: center;
  background-color: var(--text-color-subtle);
}
.lightMode.narrow nav {
  background-color: var(--text-color-more-subtle);
}
.narrow nav:hover {
  /* background-color: var(--background-color); */
  opacity: 0.7;
}
.narrow nav.selected .mail :deep(a) {
  color: var(--primary-navigation-color) !important;
}
.narrow nav.selected {
  background-color: var(--brand-color);
}
.narrow nav.selected:hover {
  background-color: var(--brand-hover-color) !important;
}
</style>
